import React from 'react'
import Wrapper from './style'

const SchTab = ({children}) => {
	return (
		<Wrapper>
			{children}
		</Wrapper>
	)
}

export default SchTab
